import { createBrowserRouter } from 'react-router-dom';
import { ProtectedView } from '@/app/protected-view';
import { Home } from '@/pages/home';
import { Login } from '@/pages/login';
import { Stores } from '@/pages/stores';

export const appRouter = () =>
  createBrowserRouter([
    {
      path: '/',
      element: <ProtectedView />,
      children: [
        {
          path: 'stores/:storeKey',
          element: <Home />,
        },
        {
          path: 'stores',
          element: <Stores />,
        },
      ],
    },
    {
      path: '/login',
      element: <Login />,
    },
  ]);
